<template>
    <div class="container">
        <div class="content">
            <img :src="infoObj.image" alt="">
        </div>
    </div>
</template>
<script>
import { listspecial, listcolumnZt,infocolumnZt } from "@/api/pop";
export default {
    name: 'TextAll',
    data() {
        return {
            infoObj: {},
            id:'',
        }
    },
    methods: {
        getList() {
            infocolumnZt(this.id).then((res) => {
                this.infoObj = res.data.data;
            });
        },
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        this.id = params.get("id");
        this.getList();
    }
}
</script>
<style scoped lang="scss">
.container {
    width: 100%;
    display: flex;
    justify-content: center;

    .content {
        width: 1232px;
        img{
            width: 1232px;

        }
    }
}
</style>